var _style, _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTb9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000116214679619823922460000010695597827821000628_",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 44,
    height: 44,
    viewBox: "0 0 42 42",
    style: {
      enableBackground: "new 0 0 42 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F9F4C7;stroke:#231F20;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 42,
    width: 42,
    x: 0,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.8,22.1c-0.7,0.8-1.5,1.4-2.3,1.8s-1.8,0.6-2.8,0.6S17.8,24.4,17,24s-1.6-0.9-2.2-1.6s-1.1-1.5-1.4-2.4 s-0.5-1.9-0.5-2.9c0-1.1,0.2-2.1,0.6-3.1s0.9-1.8,1.6-2.5s1.5-1.3,2.5-1.7s2-0.6,3.2-0.6c1.3,0,2.5,0.2,3.6,0.7s1.9,1.2,2.7,2.1 s1.3,2.1,1.7,3.5s0.6,3,0.6,4.8c0,2-0.2,3.8-0.6,5.3s-1,2.8-1.8,3.8s-1.7,1.8-2.8,2.3c-1.1,0.5-2.3,0.8-3.7,0.8s-2.5-0.3-3.5-0.8 S15,30.8,14.5,30s-0.8-1.5-0.8-2.2c0-0.4,0.2-0.8,0.5-1.2s0.7-0.5,1.2-0.5c0.5,0,0.9,0.1,1.2,0.4s0.6,0.6,0.8,1.1 c0.2,0.6,0.6,1.1,1.1,1.5s1.1,0.6,1.8,0.6c0.6,0,1.2-0.1,1.7-0.5s1-0.7,1.4-1.3C24.2,26.9,24.7,24.9,24.8,22.1L24.8,22.1z  M24.5,17.3c0-0.7-0.1-1.4-0.3-2s-0.5-1.1-0.8-1.6s-0.8-0.8-1.2-1s-1-0.4-1.6-0.4c-1,0-1.8,0.4-2.5,1.3s-1,2-1,3.4s0.3,2.5,1,3.3 s1.6,1.2,2.6,1.2c0.6,0,1.3-0.2,1.9-0.5s1.1-0.8,1.4-1.5S24.5,18.2,24.5,17.3L24.5,17.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTb9);
export default __webpack_public_path__ + "static/media/Tb9.d8fcab6eca1e348b9c3917c7f0624b45.svg";
export { ForwardRef as ReactComponent };